import { createAction, handleActions } from 'redux-actions';
import {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest, call, put } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';
import * as chanceApi from '../../lib/api/chance';

import { finishLoading, startLoading } from '../loading';

const [VIEW_TECH, VIEW_TECH_SUCCESS, VIEW_TECH_FAILURE] =
  createRequestActionTypes('chance/VIEW_TECH');
export const viewTech = createAction(VIEW_TECH, (id) => id);
//const viewTechSaga = createRequestSaga(VIEW_TECH, techApi.getTechById);

const UNLOAD_TECH = 'chance/UNLOAD_TECH';
export const unloadTech = createAction(UNLOAD_TECH);

const SET_TECH = 'chance/SET_TECH';
export const setTech = createAction(SET_TECH, (tech) => tech);


//tech를 가져올때 project 정보도 가져와야함..
function* viewTechSaga(action) {
  yield put(startLoading(VIEW_TECH));

  try{
    const techRes = yield call(techApi.getTechById, action.payload);
    const tech = techRes.data.info;
    let project = null;

    if(tech){
      const projectRes = yield call(chanceApi.getChance, tech.prjUuid);
      project = projectRes.data.info;
    }

    


    yield put({
      type: VIEW_TECH_SUCCESS,
      payload: {
       tech:tech,
       project:project
      },
    });
    
  } catch (e) {
    yield put({
      type: VIEW_TECH_FAILURE,
      payload: e,
      error: true,
    });
  }

  yield put(finishLoading(VIEW_TECH));
}


export function* techSaga() {
  yield takeLatest(VIEW_TECH, viewTechSaga);
}



const initialState = {
  tech: null,
  project:null,
  error: null,
};

const tech = handleActions(
  {
    [VIEW_TECH_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      tech: data.tech,
      project: data.project,
      techPlan:data.techPlan,
    }),
    [VIEW_TECH_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_TECH]: () => initialState,
    [SET_TECH]: (state, { payload: tech }) => ({
      ...state,
      tech: tech,
    }), 
  },
  initialState,
);

export default tech;
